<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <!--Viewing-->
            <div class="UserViewing" v-show="!isEditing">
              <div class="form-group col-md-5">
                <p style="font-size:35px">{{workflowGroup.name}}</p>
                <p>{{workflowNamesByKeys(workflowGroup.workflow_keys)}}</p>
                <br>
                <button v-on:click="edit" v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99" type="button" class="btn  btn-default form-group">Edit</button>
                <button v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == 99" type="button" data-toggle="modal" data-target="#deleteWorkflowGroup" class="btn btn-danger form-group rightey">Delete Group</button>

              </div>
            </div>
            <!--Editing-->
            <div class="UserEditing col-md-5" v-show="isEditing">
              <form-text ref="name" label="Name" name="name" v-model="workflowGroupEdit.name" validation="required"></form-text>
              <v-select placeholder="Workfow(s)" multiple :options="workflows" validation="required" :value.sync="write_workflows" :items="write_workflows" label="name" name="workflows"></v-select>              
              <br>
              <div class="form-group">
                <button v-on:click="cancelEdit" type="button" class="btn btn-default">Cancel</button>
                <button v-on:click="submitEdit" type="button" class="btn btn-success">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /.col-md-12 -->
    </div>

    <deleteworkflowgroup @deleteWorkflowGroup="deleteWorkflowGroup" name="deleteWorkflowGroup"></deleteworkflowgroup>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import ActiveFormCheckbox from '../../elements/Form/ActiveFormCheckbox'
import FormTextMask from '../../elements/Form/FormTextMask'
import FormSelect from '../../elements/Form/FormSelect'
import database from '../../webmaster/Database/database'
import store from '../../webmaster/Store/vuex'
import vSelect from 'vue-select'

import DeleteWorkflowGroup from './DeleteWorkflowGroup'

Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'workflowgroupdetail',
  components:{
    'form-text':FormText,
    'form-text-mask':FormTextMask,
    'form-checkbox':ActiveFormCheckbox,
    'form-select':FormSelect,
    'deleteworkflowgroup': DeleteWorkflowGroup,
    vSelect
  },
  data () {
    return {
      workflowGroup:{},
      workflowGroupEdit:{},
      isEditing: false,
      inputTypes: [{'name': "Number", '.key': "number"}, {'name': "Text", '.key': "text"}, {'name': "True/False", '.key': "bool"}],
      org: store.state.usermain,
      workflows: [],
      write_workflows: [],
    }
  },
  created:function(){
    this.fetchWorkflows()
  },
  mounted:function(){
    this.fetchWorkflowGroup()
  },
  methods: {
    edit: function(){
      this.isEditing = true;
    },
    cancelEdit: function(){
      this.isEditing = false;
    },
    /* fetchAll: function() {
      this.fetchWorkflows()
      this.fetchWorkflowGroup()
    }, */
    fetchWorkflows:function(){
      //Get all workflows
      var workflowsRef = '/orgs/' + this.$store.state.usermain.curOrg.id + '/meta_workflows'

      this.$bindAsArray('workflows', database.getRef(workflowsRef));
    },
    fetchWorkflowGroup: function(){
      var self = this;

      this.$bindAsObject('workflowGroup', database.getRef('/orgs/' + this.$store.state.usermain.curOrg.id + '/workflow_groups/' + this.$route.params.id), null, function(){
        this.workflowGroupEdit = Object.assign({}, this.workflowGroupEdit, this.workflowGroup);

        self.workflowGroup["workflow_keys"].forEach(function (workflowKey) {
          self.write_workflows.push(self.workflows.find(function(_workflow) {
            return _workflow[".key"] == workflowKey
          }))
        })
      });
    },
    submitEdit: function(){
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        var curOrgId = self.$store.state.usermain.curOrg.id
        var updates = {};

        var workflowKeys = [];

        if (self.write_workflows.length < 1) {
          return;
        }

        self.write_workflows.forEach(function (workflow) {
          workflowKeys.push(workflow[".key"])
        })

        updates['/orgs/' + curOrgId + '/workflow_groups/' + this.$route.params.id] = {
          "name": self.workflowGroupEdit.name,
          "workflow_keys": workflowKeys,
        };

        database.getDb().ref().update(updates, function(){
          self.isEditing = false
        });
      }, () => {});
    },
    workflowNamesByKeys:function(workflowKeys) {
      var self = this
    
      var workflowNames = []
    
      if (workflowKeys != null) {
        workflowKeys.forEach(workflowKey => {
          var foundWorkflow = self.workflows.find(function(_workflow) {
            return _workflow[".key"] === workflowKey
          });

          workflowNames.push(foundWorkflow["name"])
        })

        return workflowNames.join(", ")
      }

      return ""
    },
    deleteWorkflowGroup: function() {
        var curOrgId = this.$store.state.usermain.curOrg.id

        database.getDb().ref('/orgs/' + curOrgId + '/workflow_groups/' + this.$route.params.id).remove();
        this.$router.push('/admin/workflowgroups');
    }
  }
}
</script>

<!-- Add "scoped" group to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// WorkflowGroupDetail.vue?4e79dd30